import React from "react"
import BackgroundImage from "gatsby-background-image"
import { useStaticQuery, graphql } from "gatsby"

const Hero = ({ fluid = null, className = "", children }) => {
  const data = useStaticQuery(graphql`
    query MyQuery {
      file(relativePath: { eq: "William- Nature Picture.JPG" }) {
        id
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  const image = fluid || data.file.childImageSharp.fluid

  return (
    <BackgroundImage
      fluid={image}
      className={`md:h-screen overflow-hidden relative  z-0 ${className}`}
      style={{ backgroundPosition: "center", maxHeight: 1000 }}
    >
      {children}
    </BackgroundImage>
  )
}

export default Hero
